module.exports = __webpack_public_path__ + "media/images/logo-negativ-b31a7c977a158977fca104f909dc6c62.png";